import React, { PureComponent } from 'react';

export default class CustomCircleProgress extends PureComponent {
  state = {};
  
  render() {
    if (this.props.visible) {
      // ENSURE CIRCLE WITHIN SVG TAG HAS CX AND CY MATCH THE
      // ACTUAL CENTER OF DIMENSIONS PROVIDED FOR CLASS 
      // circular VIA INDEX.SCSS
      return <svg className="circular">
        <circle 
          className="path" 
          cx="30" 
          cy="30" 
          r="20" 
          fill="none" 
          strokeWidth="5" 
          strokeMiterlimit="10" 
          style={{ stroke: this.props.color }} />
      </svg>
    }

    return null;
  }
}


// WEBPACK FOOTER //
// ./src/CustomCircleProgress.jsx